<!--
  네비게이션
  동기화 현황 알람

  @since: 2020-05-19
  @updater: mk.ko
-->

<template>
  <li v-if="authSync"
      :class="`title dep-none navi-notice-group ${isShowNav ? '' : 'navi-notice-group-footer'} ${isMouseOver ? 'on': ''}`">

    <!-- Navigation sync alarm badge-tooltip -->
    <div class="list-inline">
      <a href="javascript:;"
       class="cursor-pointer navi-1dep-sync"
       @click="popupNewWindow"
       @mouseover="isMouseOver = true"
       @mouseleave="isMouseOver = false">
      <div :class="['badge', 'badge-sync', badgeClass]">
        <span class="badge-icon">

          <!-- success -->
          <template v-if="syncInfo.sync_status === 0">
            <q-icon name="sync"></q-icon>
          </template>

          <!-- fail -->
          <template v-if="syncInfo.sync_status === 1">
            <q-icon name="sync_problem"></q-icon>
          </template>

          <!-- pending -->
          <template v-if="syncInfo.sync_status === 2">
            <q-icon name="sync" class="rotating-slowly"></q-icon>
          </template>

          <!-- progress -->
          <template v-if="syncInfo.sync_status === 3">
            <q-icon name="sync" class="rotating"></q-icon>
          </template>

          <!-- disabled -->
          <template v-if="syncInfo.sync_status === 4">
            <q-icon name="sync_disabled"></q-icon>
          </template>

        </span>
      </div>
      </a>

      <a href="javascript:;"
         v-if="isShowNav"
         :style="{'padding-left':'10px !important'}"
         class="alert-notice-cursor"
         @click="popupNewWindow"
         @mouseover="isMouseOver = true"
         @mouseleave="isMouseOver = false"
      >{{ $t('cmn.syncStatus') }}</a>

      <q-tooltip self="center left"
                 anchor="top right"
                 class="bs bs-q-tooltip bs-q-tooltip-default"
                 :offset="[5, 15]">

        <div class="list-inline">

          <!-- success -->
          <div v-if="syncInfo.sync_status === 0">
            {{ $t('cmn.syncStatus') }} (
              {{ $t('cmn.totalCountSimple') }} {{ i18nFunction }}: {{ syncInfo.sync_total }}{{ i18nCount }}
              / <span class="textG">{{ $t('cmn.complete') }}: {{ syncInfo.sync_summary.success }}{{ i18nCount }}</span>
            )
          </div>
          <!-- fail -->
          <div v-if="syncInfo.sync_status === 1">
            {{ $t('cmn.syncStatus') }} (
              {{ $t('cmn.totalCountSimple') }} {{ i18nFunction }}: {{ syncInfo.sync_total }}{{ i18nCount }}
              / {{ $t('cmn.complete') }}: {{ syncInfo.sync_summary.success }}{{ i18nCount }}
              / <span class="textR">{{ $t('cmn.fail') }}: {{ syncInfo.sync_summary.fail }}{{ i18nCount }}</span>
            )
          </div>
          <!-- pending -->
          <div v-if="syncInfo.sync_status === 2">
            {{ $t('cmn.syncStatus') }} (
              {{ $t('cmn.totalCountSimple') }} {{ i18nFunction }}: {{ syncInfo.sync_total }}{{ i18nCount }}
              / {{ $t('cmn.fail') }}: {{ syncInfo.sync_summary.fail }}{{ i18nCount }}
              / {{ $t('cmn.complete') }}: {{ syncInfo.sync_summary.success }}{{ i18nCount }}
              / <span class="textB">{{ $t('sm.synchronizationStatus_synchronizationStatus_waiting') }}: {{ syncInfo.sync_summary.pending }}{{ i18nCount }}</span>
            )
          </div>
          <!-- progress -->
          <div v-if="syncInfo.sync_status === 3">
            {{ $t('cmn.syncStatus') }} (
              {{ $t('cmn.totalCountSimple') }} {{ i18nFunction }}: {{ syncInfo.sync_total }}{{ i18nCount }}
              / {{ $t('sm.synchronizationStatus_synchronizationStatus_waiting') }}: {{ syncInfo.sync_summary.pending }}{{ i18nCount }}
              / {{ $t('cmn.fail') }}: {{ syncInfo.sync_summary.fail }}{{ i18nCount }}
              / {{ $t('cmn.complete') }}: {{ syncInfo.sync_summary.success }}{{ i18nCount }}
              / <span class="textB">{{ $t('sm.synchronizationStatus_synchronizationStatus_playing') }}: {{ syncInfo.sync_summary.progress }}{{ i18nCount }}</span>
            )
          </div>
          <!-- disabled -->
          <div v-if="syncInfo.sync_status === 4">
            {{ $t('cmn.syncStatus') }} ( <span class="textGR">{{ $t('cmn.disabled') }}</span> )
          </div>

          <div v-if="syncInfo.sync_status < 0 || syncInfo.sync_status > 4">
            {{ $t('cmn.syncStatus') }}
          </div>

        </div>

      </q-tooltip>
    </div>

  </li>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'

  // utils
  import { menuCodeToHierarchyInfo } from '~/utils/multirw'
  import { newWindow } from '~/utils/newWindow'

  // plugins
  import Hub from '~/plugins/global-event-hub'

  // stores
  const
    navigationHelper = createNamespacedHelpers('common/navigation'),
    commonHelper = createNamespacedHelpers('common/common'),
    localeHelper = createNamespacedHelpers('common/locale'),
    authenticateHelper = createNamespacedHelpers('common/authenticate')

  export default {
    name: 'NavigationSync',
    components: {},
    directives: {},
    mixins: [],
    props: {},
    data () {
      return {
        isMouseOver: false,
        checkAlertTimer: void 0
        // alertLevel: 'Info'
      }
    },
    computed: {
      ...navigationHelper.mapState([
        'authSync',
        'menu'
      ]),
      ...commonHelper.mapState([
        'syncInfo',
        'preventLogoutAfterTimer',
        'newWindows',
        'isShowNav'
      ]),
      ...localeHelper.mapGetters([
        'getCurrentLocale'
      ]),
      ...authenticateHelper.mapState([
        'authToken',
        'authIssueDate',
        'authRefreshToken'
      ]),
      isNewWindow () {
        return this.$route.query.newWindow
      },
      isGeWindow () {
        try {
          return this.$route.query.geWindow || this.$store.getters['common/authenticate/isExistGeToken']
        } catch (e) {
          return false
        }
      },
      badgeClass () {
        let className = ''
        switch (this.syncInfo.sync_status) {
          case 0: // success
            className = 'badge-green'
            break

          case 1: // fail
            className = 'badge-red'
            break

          case 2: // pending
          case 3: // progress
            className = 'badge-info'
            break

          case 4: // disabled
            className = 'badge-disabled'
            break
        }
        return className
      },
      locale () {
        return this.$i18n.locale || 'ko'
      },
      i18nCount () {
        return this.locale === 'ko' ? this.$t('cmn.count') : ''
      },
      i18nFunction () {
        return this.locale === 'ko' ? this.$t('cmn.function') : _.toLower(this.$t('cmn.function'))
      }
      // syncStatusSummary () {
      //   if (typeof this.syncInfo === 'undefined') {
      //     return ''
      //   }
      //
      //   let res = `${this.$t('cmn.function')}: ${this.syncInfo.sync_total}${this.$t('cmn.count')}`
      //   const sync = this.syncInfo.sync_summary
      //   switch (this.syncInfo.sync_status) {
      //     // success
      //     case 0:
      //       res += `/${this.$t('cmn.complete')}: ${sync.success}${this.$t('cmn.count')}`
      //       break
      //
      //     // fail
      //     case 1:
      //       res += `/${this.$t('cmn.complete')}: ${sync.success}${this.$t('cmn.count')}`
      //       res += `/${this.$t('cmn.fail')}: ${sync.fail}${this.$t('cmn.count')}`
      //       break
      //
      //     // pending
      //     case 2:
      //       res += `/${this.$t('sm.synchronizationStatus_synchronizationStatus_waiting')}: ${sync.pending}${this.$t('cmn.count')}`
      //       break
      //
      //     // progress
      //     case 3:
      //       res += `/${this.$t('sm.synchronizationStatus_synchronizationStatus_playing')}: ${sync.progress}${this.$t('cmn.count')}`
      //       res += `/${this.$t('sm.synchronizationStatus_synchronizationStatus_waiting')}: ${sync.pending}${this.$t('cmn.count')}`
      //       res += `/${this.$t('cmn.complete')}: ${sync.success}${this.$t('cmn.count')}`
      //       res += `/${this.$t('cmn.fail')}: ${sync.fail}${this.$t('cmn.count')}`
      //       break
      //
      //     // disabled
      //     case 4:
      //       res = this.$t('cmn.disabled')
      //       break
      //   }
      //   return res
      // }
    },
    methods: {
      ...commonHelper.mapActions([
        'getSyncStatus'
      ]),
      movePage () {
        const path = '/policyManagement/synchronization/syncStatus'
        this.$emit('movePage', path)
      },
      popupNewWindow () {
        try {
          const MENU_SYNCHRONIZATION_STATUS = 360101, // 360101: 동기화 현황
            menuInfo = menuCodeToHierarchyInfo(MENU_SYNCHRONIZATION_STATUS, this.menu)

          let name = '', menuName = ''

          name = _.map(menuInfo, 'key').join('-')
          menuName = menuInfo[menuInfo.length - 1].name

          let routeData = this.$router.resolve({
            name,
            query: {
              menuName: menuName,
              newWindow: true,
              deviceTime: this.agentTime,
              targetTab: 'funcSyncStatTab'
            }
          })

          newWindow({
            store: this.$store,
            url: routeData.href
          })
        } catch (e) {
          this.$log('[Navigation Sync Status GUI Error ()]', e)
        }
      },
      // TAMS
      setAlertTimer () {
        this.checkAlertTimer = setTimeout(this.detectAlarm, 60000)
      },
      stopAlertTimer () {
        if (typeof this.checkAlertTimer !== 'undefined') {
          clearTimeout(this.checkAlertTimer)
        }
      },
      async detectAlarm () {
        if (typeof this.checkAlertTimer !== 'undefined') {
          clearTimeout(this.checkAlertTimer)
        }

        await this.getSyncStatus()

        // 자동 세션 아웃 시간 만료 후 timer 호출 방지
        if (!this.preventLogoutAfterTimer) {
          this.setAlertTimer()
        } else {
          if (typeof this.checkAlertTimer !== 'undefined') {
            clearTimeout(this.checkAlertTimer)
          }
        }
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {
      if (!this.isNewWindow) {
        this.$nextTick(() => {
          // 알람 이벤트 감지
          this.detectAlarm()

          // 설정 복구 도중, 전역 타이머 동작되지 않도록 타이머 관리열 추가
          Hub.addTimer('syncStatusTimer', {
            start: this.setAlertTimer,
            stop: this.stopAlertTimer
          })
        })
      }
    },
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {},
    beforeRouteLeave (to, from, next) {
      if (typeof this.checkAlertTimer !== 'undefined') {
        clearTimeout(this.checkAlertTimer)
      }
      next()
    },
    destroyed () {},
    errorCaptured () {},
    watch: {}
  }
</script>

<style scoped>
  .alert-notice-cursor {
    cursor: pointer;
  }

  @-webkit-keyframes rotating {
    from {
      -webkit-transform: rotate(360deg);
    }
    to {
      -webkit-transform: rotate(0deg);
    }
  }

  .rotating {
    -webkit-animation: rotating 2s linear infinite;
  }
  .rotating-slowly {
    -webkit-animation: rotating 6s linear infinite;
  }
  .list-inline {
    display: inline !important;
  }
  .list-inline span {
    display: inline !important;
  }

  .badge-sync {
    display: flex !important;
    flex-flow: row !important;
    justify-content: center !important;
    align-items: center !important;
    top: -1px !important;
  }
  .badge-sync .badge-icon {
    display: flex !important;
  }
</style>


